import React, { useState } from 'react'
import styles from './GroupBySelector.module.css'

const GROUP_BY_OPTIONS = [
    { value: 'user', label: 'User' },
    { value: 'project', label: 'Project' },
    { value: 'task', label: 'Task' },
    { value: 'client', label: 'Client' },
    { value: 'date', label: 'Date' },
    { value: 'week', label: 'Week' },
    { value: 'month', label: 'Month' },
    { value: 'billable', label: 'Billable' }
]

export default function GroupBySelector({ groupByFields = [], onChange }) {
    const [showAddGroupBy, setShowAddGroupBy] = useState(false)
    
    const availableOptions = GROUP_BY_OPTIONS.filter(option => 
        !groupByFields.includes(option.value)
    )
    
    const addGroupBy = (value) => {
        if (value && !groupByFields.includes(value)) {
            onChange([...groupByFields, value])
        }
        setShowAddGroupBy(false)
    }
    
    const removeGroupBy = (value) => {
        onChange(groupByFields.filter(field => field !== value))
    }
    
    const moveGroupBy = (fromIndex, toIndex) => {
        const newFields = [...groupByFields]
        const [movedItem] = newFields.splice(fromIndex, 1)
        newFields.splice(toIndex, 0, movedItem)
        onChange(newFields)
    }
    
    const getOptionLabel = (value) => {
        return GROUP_BY_OPTIONS.find(option => option.value === value)?.label || value
    }
    
    return (
        <div className={styles.groupBySelector}>
            <div className={styles.groupByHeader}>
                <span className={styles.groupByLabel}>Group by:</span>
                {groupByFields.length === 0 && (
                    <span className={styles.noGrouping}>(None)</span>
                )}
            </div>
            
            {/* Current Group By Fields */}
            <div className={styles.groupByTags}>
                {groupByFields.map((field, index) => (
                    <div key={field} className={styles.groupByTag}>
                        <span className={styles.groupByOrder}>{index + 1}</span>
                        <span className={styles.groupByText}>{getOptionLabel(field)}</span>
                        <div className={styles.groupByActions}>
                            {index > 0 && (
                                <button
                                    className={styles.moveButton}
                                    onClick={() => moveGroupBy(index, index - 1)}
                                    title="Move up"
                                >
                                    ↑
                                </button>
                            )}
                            {index < groupByFields.length - 1 && (
                                <button
                                    className={styles.moveButton}
                                    onClick={() => moveGroupBy(index, index + 1)}
                                    title="Move down"
                                >
                                    ↓
                                </button>
                            )}
                            <button
                                className={styles.removeButton}
                                onClick={() => removeGroupBy(field)}
                                title="Remove"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            
            {/* Add Group By Button */}
            {availableOptions.length > 0 && (
                <div className={styles.addGroupBy}>
                    {!showAddGroupBy ? (
                        <button
                            className={styles.addGroupByButton}
                            onClick={() => setShowAddGroupBy(true)}
                        >
                            + Add Group By
                        </button>
                    ) : (
                        <div className={styles.addGroupByDropdown}>
                            <select
                                className={styles.groupBySelect}
                                onChange={(e) => addGroupBy(e.target.value)}
                                value=""
                            >
                                <option value="">Select grouping...</option>
                                {availableOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            <button
                                className={styles.cancelButton}
                                onClick={() => setShowAddGroupBy(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}